import { TW_HomeWorkspacesDropLineHorizontal, TW_HomeWorkspacesDropLineVertical } from "@utils/twClasses";
import { WorkspaceDropPosition } from "@utils/workspacesOrder";

// Distance between the edge of a card and the middle of the gap of the list (gap-4), line width included
const GAP_MIDDLE_OFFSET = -9;

interface WorkspaceDropLineProps {
  position: WorkspaceDropPosition;
  // Single column: the cards follow each other from top to bottom, the line is horizontal
  singleColumn: boolean;
  color: string;
}

// Line showing where the dragged workspace is dropped, next to the card which holds it (relative)
function WorkspaceDropLine({ position, singleColumn, color }: WorkspaceDropLineProps) {
  const before = position === 'before';
  const offset = singleColumn
    ? (before ? { top: GAP_MIDDLE_OFFSET } : { bottom: GAP_MIDDLE_OFFSET })
    : (before ? { left: GAP_MIDDLE_OFFSET } : { right: GAP_MIDDLE_OFFSET });

  return (
    <div
      className={singleColumn ? TW_HomeWorkspacesDropLineHorizontal : TW_HomeWorkspacesDropLineVertical}
      style={{
        ...offset,
        backgroundColor: color,
        boxShadow: `0 0 4px ${color}`
      }}
    />
  );
}

export default WorkspaceDropLine;
